const workshops = [
  {
    id: 1,
    title: "Konferensi Pendidikan Indonesia 2026",
    organizer: "Konferensi Pendidikan Indonesia",
    speaker: "Rizky, M.Kom",
    category: "Konferensi Pendidikan",
    mode: "Offline",

    date: "Rabu, 1 Juli 2026",
    time: "09.00 WIB",
    duration: "1 Hari",

    location: "Auditorium Universitas Negeri Yogyakarta (UNY)",
    image: "/workshops/event1.jpg",
    thumbnail: "/workshops/event1.jpg",
    images: ["/workshops/event1.jpg"],

    description:
      "Konferensi Pendidikan Indonesia 2026 menghadirkan Studio Intervensi bertajuk Memperluas Jejaring dan Memperkuat Dampak Pendidikan melalui Belajar Raya Daerah.",

    registerLink: "https://kpi.lingkardaerahbelajar.id",

    reward: 100,
    followers: "3.400 peserta",

    createdBy: "admin",
    status: "Upcoming",
    favorite: false,
  },

  {
    id: 2,
    title: "Workshop Mendesain Edugame",
    organizer: "Kids Center Indonesia",
    speaker: "Rizky, M.Kom",
    category: "Edugame",
    mode: "Online",

    date: "Kamis, 5 Februari 2026",
    time: "19.00 WIB",
    duration: "2 Jam",

    location: "Google Meet",
    image: "/workshops/event2.jpg",
    thumbnail: "/workshops/event2.jpg",
    images: ["/workshops/event2.jpg"],

    description:
      "Workshop membahas cara mendesain boardgame edukasi sesuai kurikulum dan kerangka kerja pengembangan edugame.",

    registerLink: "https://www.instagram.com/p/DUKAp5bktuK/?igsh=bDMxY3Vwc3ZiejZw",

    reward: 100,
    followers: "1.250 peserta",

    createdBy: "admin",
    status: "Upcoming",
    favorite: false,
  },

  {
    id: 3,
    title: "17 Kesalahan Fatal Membuat Anak Terlambat Bisa Membaca",
    organizer: "Marica Indonesia",
    speaker: "Dr. Nur Tsuroyah, M.Pd",
    category: "Literasi",
    mode: "Offline",

    date: "Senin, 15 September 2025",
    time: "09.00 - 16.00 WIB",
    duration: "1 Hari",

    location: "Hotel Savita Garden Inn",
    image: "/workshops/event3.jpg",
    thumbnail: "/workshops/event3.jpg",
    images: ["/workshops/event3.jpg"],

    description:
      "Workshop literasi mengenai strategi mengajarkan membaca tanpa menghafal huruf serta menghindari kesalahan umum dalam proses belajar membaca.",

    registerLink: "https://www.instagram.com/p/DOkUCrVEt_C/?igsh=MXkxdXh0bmV5dDMyeQ",

    reward: 120,
    followers: "500 peserta",

    createdBy: "admin",
    status: "Selesai",
    favorite: false,
  },

  {
    id: 4,
    title: "Curhat Publisher",
    organizer: "Kids Center Indonesia",
    speaker: "Maya Tauriana",
    category: "Edugame",
    mode: "Online",

    date: "Kamis, 19 Februari 2026",
    time: "19.00 WIB",
    duration: "2 Jam",

    location: "Google Meet",
    image: "/workshops/event4.jpg",
    thumbnail: "/workshops/event4.jpg",
    images: ["/workshops/event4.jpg"],

    description:
      "Workshop membahas kesalahan umum saat pitching ke publisher, tips agar proposal diterima, dan template presentasi yang efektif.",

    registerLink: "https://www.instagram.com/p/DU1P9ktk-8x/?igsh=Y2FlNWplNXgzZnc4",

    reward: 100,
    followers: "860 peserta",

    createdBy: "admin",
    status: "Upcoming",
    favorite: false,
  },
];

export default workshops;